export const isPublicRoute = url => {
  const publicRoutes = [
    '/Api/V8/custom/portal/forgot-password',
    '/Api/V8/custom/portal/login',
    '/Api/V8/custom/portal/refresh-token',
    '/Api/V8/custom/portal/generate-access-token',
    // QR Pages - Giveback Intake public routes (only actually used APIs)
    '/Api/V8/custom/qr/process-customer-basic-information',
    '/Api/V8/custom/customer/verify-cell',
    '/Api/V8/custom/customer/verify-email-otp',
    '/Api/V8/custom/customer/send-number-verification-sms',
    '/Api/V8/custom/customer/send-otp-via-email',
    '/Api/V8/custom/customer/update-customer',
    // Secure Link - Upload Documents public routes (only actually used APIs)
    '/Api/V8/custom/customer/get-documents',
    '/Api/V8/custom/get-secure-link-other-file-information',
    '/Api/V8/custom/get-secure-link-information',
    '/Api/V8/custom/verify-secure-link-otp',
    '/Api/V8/custom/customer/add-item-in-sharefile',
    '/Api/V8/custom/customer/update-module-fields'
  ]
  return publicRoutes.some(route => url.includes(route))
}

/**
 * Check if the current page is a secure link upload page
 * This is used to handle token expiration gracefully without redirecting to login
 */
export const isSecureLinkPage = () => {
  if (typeof window === 'undefined') return false
  const currentPath = window.location.pathname
  return (
    currentPath.includes('/public/upload-documents') ||
    currentPath.includes('/upload-documents') ||
    currentPath.includes('/public/validate/email') ||
    currentPath.includes('/validate/email')
  )
}
